import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';

export const AdminTransactionCodesPage = () => {
  return (
    <>
      <Helmet>
        <title>Transaction Codes - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
